import BaseDialog from '@/components/BaseDialog'
import BaseDrawer from '@/components/BaseDrawer'
import { DIMENSION_TYPE } from '../constant'

/**
 * 维度弹框
 * @param {*} param0 
 * @returns 
 */
export function dimensionEditModal({ props, cbs, title  }) {
    return new BaseDialog({
        component: ()=>import('./dimensionEditModal/'),
        options: {
            width: '500px',
            title: `维度分组-${title}`,
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

/**
 * 筛选弹框
 * @param {*} param0 
 * @returns 
 */
export function conditionEditModal({ props, cbs, title  }) {
    const modalWidth = (()=> {
        const type = props.dimension.config.type;
        switch (type) {
            case DIMENSION_TYPE.CONTENT:
            case DIMENSION_TYPE.CONTENT_DIMENSION:
                return '600px';
            case DIMENSION_TYPE.DATE:
                return '450px';
            default:
                return '600px';
        }
        
    })();
    return new BaseDialog({
        component: ()=>import('./conditionEditModal/'),
        options: {
            width: modalWidth,
            title: props.title,
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
};
/**
 * 使用模板
 * @param {*} param0 
 * @returns 
 */
export function useTempModal ({ props, cbs }) {
    return new BaseDrawer({
        component: ()=>import('./useTempModal/'),
        options: {
            size: '600px',
            'close-on-press-escape': false,
            wrapperClosable: false,
            'custom-class': 'custom-drawer-header',
            title: '已选条件模板',
        },
        props,
        cbs,
    })
}
/**
 * 保存模板
 * @param {*} param0 
 * @returns 
 */
export function saveTempModal({ props, cbs  }) {
    return new BaseDialog({
        component: ()=>import('./saveTempModal.vue'),
        options: {
            width: '550px',
            title: `保存模板`,
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
/**
 * 导出自定义名称
 * @param {*} param0 
 * @returns 
 */
export function exportDataModal({ props, cbs  }) {
    return new BaseDialog({
        component: ()=>import('./exportDataModal.vue'),
        options: {
            width: '750px',
            title: `导出-自定义文件名称`,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
/**
 * 全屏预览
 * @param {*} param0 
 * @returns 
 */
export function fullScreenPreviewModal({ props }) {
    return new BaseDialog({
        component: ()=>import('./fullScreenPreviewModal.vue'),
        options: {
            fullscreen: true,
            title: `全屏查看`,
            closeOnClickModal:false,
        },
        props,
    })
}